module.exports = __webpack_public_path__ + "img/yj_bless_opening.b312fcab.png";